module.exports = __webpack_public_path__ + "static/media/enterprisedashboard.bd023065.PNG";